// src/pages/accounting/accounts/GeneralSalesAccountForm.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./GeneralSalesAccountForm.module.css";
import api from "../../../api";

export default function GeneralSalesAccountForm() {
  const navigate = useNavigate();

  // ✅ 페이지 제목 설정
  useEffect(() => {
    document.title = "(일반) 매출 계정과목 등록";
  }, []); // eslint-disable-line

  // ✅ 사업구분별 예시 데이터 (참고용)
  const DETAIL_MAP = {
    본사: ["1. 통장이자", "1. 지원금", "카드포인트", "1. 순세계잉여금 이월액"],
    용역사업: ["용역"],
    카페사업: [
      "CAFE_INN 가산점 판매",
      "CAFE_INN 독산점 판매",
      "CAFE_INN 금나래점 판매",
    ],
    환경사업: ["소독", "냉난방기", "기타"],
  };

  // ✅ 기본 폼 상태
  const [form, setForm] = useState({
    category: "",
    gwang: "",
    hang: "",
    sehang: "",
    mok: "",
    semok: "",
    detail: "",
    sangse: "",  // ✅ 추가
    description: "",
    use_yn: true,
  });

  // ✅ category 변경 시 detail 초기화
  useEffect(() => {
    setForm((prev) => ({ ...prev, detail: "", sangse: "" }));  // ✅ sangse도 초기화
  }, [form.category]);

  // ✅ 입력 핸들러
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ✅ 저장
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("📤 저장할 데이터:", form);
      await api.post("accounting/accounts/general-sales/create/", form);

      alert("✅ 매출 계정과목이 성공적으로 저장되었습니다.");
      navigate("/accounting/accounts/sales");
    } catch (error) {
      console.error("❌ 저장 실패:", error);
      alert("저장 중 오류가 발생했습니다.\n" + (error.response?.data?.detail || ""));
    }
  };

  return (
    <div className={styles.pageWrap}>
      <h2>(일반) 매출 계정과목 등록</h2>

      <div className={styles.formCard}>
        <form onSubmit={handleSubmit}>
          {/* ✅ 사업구분 */}
          <div className={styles.formRow}>
            <label htmlFor="category">사업구분</label>
            <select
              id="category"
              name="category"
              value={form.category}
              onChange={handleChange}
              required
            >
              <option value="">선택</option>
              {Object.keys(DETAIL_MAP).map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>

          {/* ✅ 회계 분류 */}
          <div className={styles.formRow}>
            <label htmlFor="gwang">관</label>
            <input
              id="gwang"
              name="gwang"
              value={form.gwang}
              onChange={handleChange}
              placeholder="예: 600 사업수익"
              required
            />
          </div>

          <div className={styles.formRow}>
            <label htmlFor="hang">항</label>
            <input
              id="hang"
              name="hang"
              value={form.hang}
              onChange={handleChange}
              placeholder="예: 610 영업수익"
              required
            />
          </div>

          <div className={styles.formRow}>
            <label htmlFor="sehang">세항</label>
            <input
              id="sehang"
              name="sehang"
              value={form.sehang}
              onChange={handleChange}
              placeholder="예: 622 관리사업수익"
              required
            />
          </div>

          <div className={styles.formRow}>
            <label htmlFor="mok">목</label>
            <input
              id="mok"
              name="mok"
              value={form.mok}
              onChange={handleChange}
              placeholder="예: 622-01 관리사업수익"
            />
          </div>

          <div className={styles.formRow}>
            <label htmlFor="semok">세목</label>
            <input
              id="semok"
              name="semok"
              value={form.semok}
              onChange={handleChange}
              placeholder="예: 환경사업"
            />
          </div>

          {/* ✅ 세부 (입력 가능 + 안내문은 다음 줄로 분리) */}
          <div className={styles.formRow}>
            <label htmlFor="detail">세부</label>
            <input
              id="detail"
              name="detail"
              value={form.detail}
              onChange={handleChange}
              placeholder="예: 냉난방기 수리비, 관리수수료 등 자유 입력"
            />
          </div>
          <small
            style={{
              color: "#6b7280",
              marginLeft: "140px",
              display: "block",
              lineHeight: "1.6",
            }}
          >
            ※ 자유 입력 가능 (사업구분: {form.category || "미선택"})
            {DETAIL_MAP[form.category] && (
              <> / 기존 예시: {DETAIL_MAP[form.category].join(", ")}</>
            )}
          </small>

          {/* ✅ 상세 (추가) */}
          <div className={styles.formRow}>
            <label htmlFor="sangse">상세 (선택)</label>
            <input
              id="sangse"
              name="sangse"
              value={form.sangse}
              onChange={handleChange}
              placeholder="미선택 또는 예금 이자수익 등 자유 입력"
            />
          </div>

          {/* ✅ 비고 */}
          <div className={styles.formRow}>
            <label htmlFor="description">비고 / 설명</label>
            <textarea
              id="description"
              name="description"
              value={form.description}
              onChange={handleChange}
              placeholder="필요 시 계정 설명 입력"
            />
          </div>

          {/* ✅ 사용 여부 */}
          <div className={styles.formRowCheck}>
            <label>
              <input
                type="checkbox"
                name="use_yn"
                checked={form.use_yn}
                onChange={handleChange}
              />
              사용 여부
            </label>
          </div>

          {/* ✅ 버튼 */}
          <div className={styles.buttonBox}>
            <button type="submit" className={styles.saveBtn}>
              💾 저장
            </button>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className={styles.cancelBtn}
            >
              ↩ 취소
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}